<template>
  <DashboardCard
    ref="dashboardCard"
    :class="['mb-3 w-100 auto-h', { 'mr-2': !checkMobile(768) }]"
  >
    <div class="d-flex align-items-center justify-content-center" v-if="activeLoad">
      <Loader :visible="activeLoad"></Loader>
    </div>
    <img src="@/assets/star.svg" alt="Link" slot="icon" class="card-icon" />
    <span slot="title">Novidades</span>

    <div v-show="!activeLoad">
      <div class="news_wrapper pb-4" v-if="newsData.length > 0">
        <div
          v-for="news in newsData"
          :key="news.idt_aff_campaign_news"
          class="d-flex py-3"
        >
          <div class="news_date">
            <span class="text-regular"> {{ dateFormatter(news.created_at) }} </span>
          </div>
          <router-link
            @click.native="
              track(
                `noticia_${advertiser.code}_${news.idt_aff_campaign_news}`,
                'clicou_noticia'
              )
            "
            :to="{
              path: `${advertiser.code}/novidade/${news.idt_aff_campaign_news}`,
              query: queryObject,
            }"
            class="news_title_subtitle d-flex flex-column"
          >
            <strong class="news_title text-regular font-weight-bold">
              {{ titleFormatter(news.title) }}
            </strong>
            <span class="news_subtitle text-regular">
              {{ subtitleFormatter(news.subtitle) }}
            </span>
          </router-link>
        </div>
      </div>
      <div class="no-news" v-else>
        <span class="text-neutral">Aguarde novidades em breve.</span>
      </div>
    </div>

    <div class="ver-mais" v-show="newsData.length > 0 && !activeLoad">
      <router-link
        @click.native="
          track(`ver_mais_noticias_${advertiser.code}`, 'clicou_ver_mais_novidades')
        "
        class="ver-mais-button"
        :to="{ path: this.listNewsUrl, query: queryObject }"
      >
        Ver mais novidades
      </router-link>
    </div>
  </DashboardCard>
</template>

<script>
import NewsApi from '@/services/news';
import Loader from '@/components/Loader';
import DashboardCard from '@/components/DashboardCard';
import { getStringFromDate } from '@/utils/dateUtils';
import { truncateString } from '@/utils/stringUtils';

const clearFormOptions = () => ({
  idtCommEventSourceGroup: null,
  qtd: null,
  hasImages: false,
  firstRow: 0,
  excludedIdtNews: null,
});

export default {
  name: 'newsCard',
  props: ['advertiser'],
  components: {
    DashboardCard,
    Loader,
  },
  data() {
    return {
      activeLoad: true,
      newsData: [],
      options: {
        ...clearFormOptions(),
      },
    };
  },
  async created() {
    this.setOptions();
    const news = await NewsApi.getNewsList(this.options);
    this.newsData = news.lines;
    this.activeLoad = false;
  },
  computed: {
    listNewsUrl() {
      return `${this.advertiser.code}/novidades`;
    },
    queryObject() {
      const qs = window.location.search;
      const queryObject = {};
      qs.substr(1)
        .split('&')
        .forEach((_param) => {
          const param = _param.split('=');
          const key = param.shift();
          const value = param.shift();
          queryObject[key] = value;
        });
      return queryObject;
    },
  },
  methods: {
    setOptions() {
      this.options.idtCommEventSourceGroup = this.advertiser.id;
      this.options.qtd = 3;
      this.options.hasImages = false;
      this.options.excludedIdtNews = 0;
    },
    dateFormatter(value) {
      return getStringFromDate(new Date(value));
    },
    titleFormatter(title) {
      return truncateString(title, 55);
    },
    subtitleFormatter(subtitle) {
      return truncateString(subtitle, 130);
    },
    checkMobile(size) {
      return window.innerWidth <= size;
    },
  },
};
</script>

<style lang="scss" scoped>
.auto-h {
  height: inherit !important;
}

.ver-mais {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;

  .ver-mais-button {
    border: 1px solid $denim;
    color: $denim;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 70px;
    height: 38px;
    @include text-size-regular();
  }
}

.news_date {
  display: flex;
  align-items: center;
  padding-right: 30px;
  color: $text-dark;
}

.news_title_subtitle {
  .news_title,
  .news_subtitle {
    line-height: 15px;
    color: $text-dark;
  }
  .news_subtitle {
    padding-top: 5px;
  }
}

.no-news {
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: center;
}

/deep/ {
  .icon {
    display: flex;
    @media screen and (max-width: $lg) {
      padding-top: 8px;
    }
  }
}
</style>
